import React, { createContext, useContext, useEffect, useState } from 'react'

type FontSize = 'small' | 'medium' | 'large'

interface ThemeContextType {
  fontSize: FontSize
  setFontSize: (fontSize: FontSize) => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

interface ThemeProviderProps {
  children: React.ReactNode
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [fontSize, setFontSizeState] = useState<FontSize>(() => {
    const savedFontSize = localStorage.getItem('interview-font-size') as FontSize
    return savedFontSize || 'large'
  })

  // Persist font size preference and ensure old global classes are removed
  useEffect(() => {
    const root = document.documentElement
    
    // Remove existing font size classes
    root.classList.remove('font-small', 'font-medium', 'font-large')
    
    localStorage.setItem('interview-font-size', fontSize)
  }, [fontSize])

  const setFontSize = (newFontSize: FontSize) => {
    setFontSizeState(newFontSize)
  }

  return (
    <ThemeContext.Provider value={{
      fontSize,
      setFontSize
    }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}